__turbopack_context__.v({
  "pressLinks": "page-module__rs8aDa__pressLinks",
  "title": "page-module__rs8aDa__title",
});
